<template>
  <v-container fluid>
    <v-layout class="hide-on-print" row wrap>
      <v-flex xs12>
        <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
          <h3 class="font-weight-bold">Plan Upgrade Details ({{ plan_detail.status }})</h3>
        </v-flex>
        <v-card>
          <v-tabs background-color="primary"
                  dark
                  fixed-tabs
                  v-model="tab"
                  height="40"
          >
            <v-tab href="#transfer-detail">
              <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
              Upgrade Details
            </v-tab>
            <v-tab href="#history">
              <v-icon class="mr-2" size="15">mdi-history</v-icon>
              Plan upgrade history
            </v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item value="transfer-detail">
                <v-card :loading="loading" class="pb-4" flat>
                  <v-card-text class="pb-0">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-alpha-t-box"
                                                  text="Upgrade Details"/>

                      </v-flex>
                      <v-layout class="pl-6 pr-2" row wrap>
                        <v-flex xs3>
                          <list-item-detail
                              :sub_title="plan_detail.plan_data.new_plan"
                              title="Plan type"/>
                        </v-flex>

                        <v-flex xs3>
                          <list-item-detail
                              :sub_title="plan_detail.plan_data.new_plan"
                              title="Reason for Upgrade"/>
                        </v-flex>

                      </v-layout>
                      <v-flex xs12>
                        <v-divider class="my-1"/>
                      </v-flex>
                      <v-flex class="d-flex justify-content-between" xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-account"
                                                  text="Traveller Details"/>

                        <v-btn
                            @click="viewTravellerData"
                            color="primary"
                            dark
                            dense
                            text
                            x-small>
                          View Traveller History
                        </v-btn>
                      </v-flex>
                      <v-flex class="pl-3" xs3>
                        <list-item-detail :sub_title="plan_detail.traveller.name"
                                          title="Traveller Name"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="plan_detail.traveller.gender"
                                          title="Traveller Gender"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="plan_detail.traveller.occupation"
                                          title="Traveller Occupation"/>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider class="my-1"/>
                      </v-flex>
                      <v-flex class="d-flex justify-content-between" xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-equal-box"
                                                  text="Current Visa Details"/>

                        <v-btn
                            @click="viewVisaDetail"
                            color="primary"
                            dark
                            dense
                            text
                            x-small>
                          View visa detail
                        </v-btn>
                      </v-flex>
                      <v-flex class="pl-3" xs3>
                        <list-item-detail :sub_title="plan_detail.visa.visa_number"
                                          title="Visa Number"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="plan_detail.visa.submission_no"
                                          title="Submission Number"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="plan_detail.visa.visa_type"
                                          title="Visa Type"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail
                            :sub_title="plan_detail.visa.start_date+' to '+plan_detail.visa.expiry_date"
                            title="Visa Duration"/>
                      </v-flex>

                      <v-flex xs12>
                        <v-divider class="my-1"/>
                      </v-flex>
                      <v-flex v-if="plan_detail.payment_info" xs12>
                        <payment-detail
                            :paid="plan_detail.paid"
                            :payment_detail="plan_detail.payment_info"
                        />
                      </v-flex>
                      <v-flex v-else xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-alpha-p-box"
                                                  text="Payment Details"/>

                        <v-layout class="pl-3 mx-0" row wrap>
                          <v-flex v-if="plan_detail.voucher_number" xs3>
                            <list-item-detail :sub_title="plan_detail.voucher_number"
                                              title="Voucher number"
                            />
                          </v-flex>
                          <v-flex xs3>
                            <list-item-detail
                                :sub_title="plan_detail.plan_data.cost"
                                title="Amount (USD)"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-footer class="sticky" color="blue darken-1" fixed height="auto">
                        <v-layout row v-if="!plan_detail.is_verified && !plan_detail.approve_rejected" wrap>
                          <v-spacer/>
                          <v-btn
                              @click="verify"
                              class="text-white"
                              color="blue ml-2"
                              v-if="plan_detail.can_verify"
                              :loading="verifyLoading"
                          >
                            Verify
                          </v-btn>
                          <v-btn
                              @click="reject"
                              color=" red lighten-1 mr-2 ml-2"
                              v-if="!plan_detail.approve_rejected && plan_detail.can_verify"
                          >
                            Reject
                          </v-btn>
                        </v-layout>
                        <v-layout row v-else wrap>
                          <v-spacer/>
                          <v-btn
                              @click="generateTippani"
                              color="primary lighten-1 ml-2"
                              v-if="showGenerateTippani && !plan_detail.approve_rejected">
                            Generate tippani
                          </v-btn>
                          <v-btn
                              :loading="voucherLoading"
                              @click="generateVoucher"
                              class="text-white"
                              color="blue ml-2"
                              v-if="plan_detail.tippani_generated && !plan_detail.voucher_generated && plan_detail.can_verify">
                            Generate voucher
                          </v-btn>
                          <v-btn
                              @click="print('voucher')"
                              class="text-white"
                              color="blue ml-2"
                              v-if="showPrintVoucher"
                          >
                            Print voucher
                          </v-btn>
                          <v-btn
                              @click="checkPaymentStatus"
                              color="primary lighten-1 ml-2"
                              v-if="plan_detail.voucher_number && !plan_detail.paid && plan_detail.can_verify"
                          >
                            Check payment status
                          </v-btn>
                          <v-btn
                              @click="checkPaymentManually"
                              color="primary lighten-1 ml-2"
                              v-if="plan_detail.voucher_generated && !plan_detail.paid && plan_detail.can_verify"
                          >
                            Pay manually
                          </v-btn>
                          <v-btn
                              @click="approve"
                              color="primary"
                              v-if="plan_detail.paid && !plan_detail.approve_rejected && plan_detail.can_approve"
                          >
                            Approve
                          </v-btn>
                          <v-btn
                              @click="reject"
                              color=" red lighten-1 mr-2 ml-2"
                              v-if="plan_detail.paid && !plan_detail.approve_rejected && plan_detail.can_approve"
                          >
                            Reject
                          </v-btn>
                          <v-btn
                              @click="printNow"
                              :loading="loading"
                              class="white--text"
                              color="primary ml-2"
                              v-if="plan_detail.visa_print_system_active && plan_detail.approve_rejected && plan_detail.can_approve && $oauth.checkIfHasPermission(['print visa-plan-upgrade'])"
                          >
                            Print Visa Plan Upgrade
                          </v-btn>
                        </v-layout>
                      </v-footer>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="history">
                <v-card :loading="loading" flat>
                  <visa-history :history="plan_detail.history"
                                :show_load_more="false"/>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>

      </v-flex>
      <v-flex v-if="!plan_detail.voucher_number" xs12>
        <v-dialog v-model="tippaniDialog"
                  width="800">
          <v-card class="hide-on-print">
            <v-toolbar color="blue darken-3" dark>
              <v-toolbar-title>Generate tippani</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div :class="{'hide-on-block':step === 2}">
                <v-layout row wrap>
                  <v-flex class="mt-4" xs12>
                    <div id="editor"></div>
                  </v-flex>
                </v-layout>
              </div>
              <div v-if="step === 2">
                <plan-tippani-print/>
              </div>
            </v-card-text>
            <v-card-actions class="mt-8">
              <v-spacer/>
              <v-btn @click="cancel" color="error">Cancel</v-btn>
              <v-btn @click="next" color="primary" v-if="step === 1">Next</v-btn>
              <v-btn @click="save" color="primary" v-if="step === 2">Save</v-btn>
              <v-btn @click="print('tippani')" color="primary" v-if="step === 2">Print</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>

      <v-flex xs12>
        <v-dialog v-model="approveModal" width="700px">
          <v-form class="mt-4" ref="approveRef">
            <v-card>
              <v-toolbar color="blue darken-3" dark>
                <v-toolbar-title>Approve transfer</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="pt-4">
                <v-text-field
                    :rules="[rules.required]"
                    label="Remarks *"
                    outlined
                    v-model="approveData.remarks"
                />
                <multiple-file-upload
                    :required="false"
                    label="Attachement"
                    v-model="approveData.files"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="warning">Cancel</v-btn>
                <v-btn @click="approveTransfer" color="primary">Approve</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>

        </v-dialog>
        <v-dialog v-model="rejectModal" width="700px">
          <v-card>
            <v-toolbar color="blue darken-3" dark>
              <v-toolbar-title>Reject transfer</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pt-4">
              <v-form ref="rejectRef">
                <v-textarea
                    :rules="[rules.required]"
                    label="Remarks *"
                    outlined
                    v-model="rejectData.remarks"
                />
                <multiple-file-upload v-model="rejectData.files" :label="'Attachments (If any)'"/>
              </v-form>

            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn @click="cancel" color="warning">Cancel</v-btn>
              <v-btn @click="rejectTransfer" color="primary">Reject</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <plan-tippani-print
        class="show-on-print"
        v-if="printType === 'tippani'"
    />
    <voucher-content
        :data="plan_detail"
        class="show-on-print"
        v-if=" printType === 'voucher'"
    />
    <manual-payment-dialog :url="'pay-track-manually/'+plan_detail.submission_no" @paid="amountPaid"
                           v-model="manualDialog"/>
    <cost-exemption-dialog
        :url="'exempt-cost/'+plan_detail.submission_no"
        @exempted="exempted"
        v-model="costExemptedDialog"
    />
  </v-container>

</template>

<script>
import PlanTippaniPrint from "../../../components/tippani/PlanTippaniPrint";
import ListItemDetail from "../../../components/ListItemDetail";
import HeaderText from "../../../components/HeaderText";
import DialogFile from "../../../components/FileDisplay";
import FileInput from "../../../components/FileInput";
import PaymentDetail from "../../../components/PaymentDetail";
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import TransferTippaniPrint from "../../../components/tippani/TransferTippaniPrint";
import PaidVisaDetail from "../../../views/visa/visa-request/PaidVisaDetail";
import VisaHistory from "../../../views/visa/visa-request/VisaHistory";
import OldVisaDetail from "../../../views/visa/visa-request/OldVisaDetail";


import {validationMixin} from '../../../mixins/validationMixin'
import MultipleFileUpload from "../../../components/MultipleFileUpload";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText";
import VoucherContent from "../../../components/VoucherContent";
import ManualPaymentDialog from "../../../components/dialogs/ManualPaymentDialog";
import CostExemptionDialog from "../../../components/dialogs/CostExemptionDialog";
import {PRINT_VISA_TRANSFER} from "../../../store/action-type";

export default {
  name: "PlanUpgradeView",
  components: {
    ListItemDetail,
    HeaderText,
    DialogFile,
    TransferTippaniPrint,
    FileInput,
    MultipleFileUpload,
    VoucherContent,
    ManualPaymentDialog,
    PaymentDetail,
    CostExemptionDialog,
    PlanTippaniPrint,
    ConfirmationHeaderText,
    PaidVisaDetail,
    VisaHistory,
    OldVisaDetail
  },
  data() {
    return {
      verifyLoading: false,
      tippaniDialog: false,
      step: 1,
      quill: null,
      approveModal: false,
      rejectModal: false,
      printType: null,
      loading: false,
      tab: null,
      manualDialog: false,
      costExemptedDialog: false,
      voucherLoading: false
    }
  },
  mixins: [validationMixin],
  computed: {
    plan_detail() {
      return this.$store.state.PlanUpgrade.upgrade_data;
    },
    is_verified() {
      return this.$store.state.PlanUpgrade.upgrade_data.is_verified || this.$store.state.PlanUpgrade.is_verified;
    },
    approveData() {
      return this.$store.state.PlanUpgrade.approveData;
    },
    rejectData() {
      return this.$store.state.PlanUpgrade.rejectData;
    },
    showPrintVoucher() {
      const {voucher_generated, paid} = this.plan_detail;
      return voucher_generated && !paid;
    },
    showGenerateTippani() {
      const {voucher_generated, can_verify} = this.plan_detail;
      return !voucher_generated && can_verify;
    }
  },
  methods: {
    async generateVoucher() {
      this.voucherLoading = true;
      try {
        await this.$store.dispatch('PlanUpgrade/generateVoucher');
        this.$store.commit('Notification/showSuccess', 'Voucher generated successfully');
        this.voucherLoading = false;
      } catch (e) {
        this.voucherLoading = false;
        throw e;
      }
    },
    viewTravellerData() {
      window.open('/admin/system/travellers-history/view/' + this.plan_detail.traveller.id)
      // this.$router.push({
      //     name: "TravellerDetail",
      //     params: {id: this.plan_detail.traveller.id.toString()}
      // });
    },
    viewVisaDetail() {
      window.open('/admin/system/visa-requests/view/' + this.plan_detail.visa.submission_no, '_blank')
    },
    next() {
      this.$store.commit("PlanUpgrade/setPlanUpgradeTippaniContent", this.quill.root.innerHTML);
      this.step = 2;
    },
    amountPaid() {
      this.$store.dispatch('PlanUpgrade/getPlanDetail', this.$route.params.id)
    },
    print(type) {
      this.printType = type;
      setTimeout(() => {
        window.print();

      }, 200);
    },
    async printNow(o) {
      var self = this;
      self.loading = true;
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
        // console.log(this.visa_request.prn_file_content)
          await this.$store.dispatch('PlanUpgrade/printPlanUpgrade');
          //Create a ClientPrintJob
          var cpj = new JSPM.ClientPrintJob();
          //Set Printer type (Refer to the help, there many of them!)
          cpj.clientPrinter = 0;
          cpj.printerCommandsCodePage = -1;
          //Set printer commands...
          cpj.printerCommands = self.plan_detail.prn_file_content;
          cpj.sendToClient();
          this.$store.commit("Notification/showSuccess", "Visa plan upgrade printed track generated successfully");
          self.loading = false;

      } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        self.loading = false;
        this.$store.commit('Notification/showError', "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm")
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        self.loading = false;
        this.$store.commit('Notification/showError', "JSPM has blocked this website!")
        return false;
      }

    },
    jspmWSStatus() {
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
        return true;
      else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        // alert(
        //     "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm"
        // );
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        // alert("JSPM has blocked this website!");
        return false;
      }
    },
    approve() {
      this.approveModal = true;
    },
    approveTransfer() {
      if (this.$refs.approveRef.validate()) {
        this.$store.dispatch('PlanUpgrade/approveUpgrade').then(() => {
          this.approveModal = false;
          this.$store.commit('Notification/showSuccess', 'Visa plan upgrade has been approved');
        }).catch((err) => {
          this.$store.commit('Notification/showError', 'Something went wrong')
        })
      }
    },
    rejectTransfer() {
      if (this.$refs.rejectRef.validate()) {
        this.$store.dispatch('PlanUpgrade/rejectUpgrade').then((res) => {
          this.rejectModal = false;
          this.$store.commit('Notification/showSuccess', 'Visa plan has been rejected');
        }).catch((err) => {
          console.log(err);
          this.$store.commit('Notification/showError', 'Something went wrong')
        })
      }
    },
    reject() {
      this.rejectModal = true;
    },
    exempted(data) {
      this.plan_detail.cost_exempted = true;
      this.plan_detail.plan_detail.exempt_cost = data;
      this.plan_detail.plan_detail.cost = this.plan_detail.plan_detail.cost - data;
    },
    checkPaymentStatus() {
      this.$store.dispatch('PlanUpgrade/checkPaymentStatus').then((data) => {
        this.$store.commit('Notification/showSuccess', data.message);
      }).catch((err) => {
        this.$store.commit('Notification/showError', err.response.data.message)
      })
    },
    async verify() {
      try {
        this.verifyLoading = true;
        await this.$store.dispatch('PlanUpgrade/verifyVisaUpgrade');
        this.$store.commit('Notification/showSuccess', 'Visa plan upgrade application verified successfully')
        this.verifyLoading = false;
      } catch (e) {
        this.verifyLoading = false;
      }
    },
    async save() {
      await this.$dialog.confirm({
        text: "Are you sure want to save tippani ? (Tippani once save cannot be reverted )",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: () => {
              this.$store.dispatch('PlanUpgrade/saveTippani', this.quill.root.innerHTML).then(() => {
                this.$store.commit('Notification/showSuccess', 'Tippani has been generated');
                this.step = 1;
                this.tippaniDialog = false;
              }).catch((err) => {
                this.$store.commit('Notification/showError', err.response.data.message)
              });
            }
          }
        }
      });

    },
    cancel() {
      if (this.step === 1) {
        this.tippaniDialog = false;
      } else {
        this.step = 1;
      }
      this.approveModal = false;
      this.rejectModal = false;

    },
    generateTippani() {
      if (this.plan_detail.voucher_number) {
        window.print();
      } else {

        let tippani = "निज निवेदक @applicant_name को निवेदन मिति @applicant_date_en तदनुसार @applicant_date_np @plan_name  सुविदा  थप  गर्नका लागि पेश भएको । निजलाई अध्यागमन नियेमवली २०५१ को नियम  ३० (१ ) बमोजिम  निजको हालको भिसा मान्य रहेको अबधि सम्मका लागि @cost डलर शुल्क लिई @plan सुबिधा थप  गर्नका लागी निर्णयार्थ पेश गर्दछु |";
        this.tippaniDialog = true;
        let content = tippani;
        console.log(this.plan_detail);
        content = content.replace('@applicant_name', this.plan_detail.traveller.name);
        content = content.replace('@applicant_date_en', new Date().toISOString().substr(0, 10));
        content = content.replace('@applicant_date_np', this.plan_detail.nepali_date);
        content = content.replace('@cost', this.plan_detail.plan_data.cost);
        content = content.replace('@plan_name', this.plan_detail.plan_data.new_plan);
        content = content.replace('@plan', this.plan_detail.plan_data.new_plan);
        // content = content.replace('@office_taken_from', this.plan_detail.visa.arrived_office);
        setTimeout(() => {
          if (!this.quill)
            this.quill = new Quill('#editor', {
              theme: 'snow',
              modules: {
                toolbar: [
                  [{header: [1, 2, false]}],
                  ['bold', 'italic', 'underline'],
                ],
              },
            });
          this.quill.root.innerHTML = content;
        }, 100);
      }
    },
    checkPaymentManually() {
      this.manualDialog = true;
    }
  },
  mounted() {
    this.$store.dispatch('PlanUpgrade/getPlanDetail', this.$route.params.id)
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    const self = this;
    JSPM.JSPrintManager.WS.onStatusChanged = function () {
      if (self.jspmWSStatus()) {
        //get client installed printers
        JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
          // var options = "";
          // for (var i = 0; i < myPrinters.length; i++) {
          //   options += "<option>" + myPrinters[i] + "</option>";
          // }
          console.log(myPrinters);
          // $("#installedPrinterName").html(options);
          self.printers = myPrinters;
        });
      }
    };
  }
}
</script>
